import React from "react"
import "./custom.scss"
import EMETLAuthenticator from "./View/Components/EMETLAuthenticator"

import {
    AppContextProvider,
} from "./Model/Contexts/AppContext"

/**
 * The main app component.
 */
const App = () => {
    return (
        <AppContextProvider>
            <EMETLAuthenticator />
        </AppContextProvider>
    )
}

export default App
